import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedBtnComponent } from "./med-btn.component";

@NgModule({
  declarations: [
    MedBtnComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedBtnComponent,
  ],
})
export class MedBtnModule { }
